import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import AbstractPageReloadOverlay, { abstractMapStateToProps } from './AbstractPageReloadOverlay';
import OverlayFrame from './OverlayFrame';
/**
 * Implements a React Component for page reload overlay. Shown before the
 * conference is reloaded. Shows a warning message and counts down towards the
 * reload.
 */
class PageReloadOverlay extends AbstractPageReloadOverlay {
    /**
     * Handles cancel button click - navigates to home page.
     *
     * @returns {void}
     */
    _handleCancel = () => {
        // Clear any flags and navigate to welcome page
        localStorage.removeItem('shouldAutoRejoin');
        localStorage.removeItem('wasInConference');
        localStorage.removeItem('newMeetingAutoJoin');
        // Navigate to the root which should show WelcomePage
        window.location.replace(window.location.origin);
    };
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { isNetworkFailure, t } = this.props;
        return (React.createElement(OverlayFrame, { isLightOverlay: isNetworkFailure },
            React.createElement("div", { className: 'reload_overlay_banner' },
                React.createElement("div", { className: 'reload_overlay_banner_content' },
                    React.createElement("div", { className: 'reload_overlay_banner_header' },
                        React.createElement("div", { className: 'reload_overlay_banner_icon' },
                            React.createElement("svg", { fill: "none", height: "40", stroke: "#f59e0b", strokeWidth: "2", viewBox: "0 0 24 24", width: "40" },
                                React.createElement("path", { d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z", strokeLinecap: "round", strokeLinejoin: "round" }))),
                        React.createElement("div", { className: 'reload_overlay_banner_text' },
                            React.createElement("span", { className: 'reload_overlay_banner_title' }, t('dialog.connectionLost')))),
                    React.createElement("div", { className: 'reload_overlay_banner_actions' },
                        this._renderButton(),
                        React.createElement("button", { className: 'reload-button-cancel', onClick: this._handleCancel, type: 'button' }, t('dialog.Cancel'))))),
            React.createElement("style", null, `
                    .reload_overlay_banner {
                        position: fixed;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 9999;
                        width: 90%;
                        max-width: 450px;
                        padding: 0;
                    }
                    
                    .reload_overlay_banner_content {
                        background-color: white;
                        border-radius: 12px;
                        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
                        padding: 20px;
                        display: flex;
                        flex-direction: column;
                        gap: 12px;
                    }
                    
                    .reload_overlay_banner_header {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        justify-content: center;
                    }
                    
                    .reload_overlay_banner_title {
                        font-size: 1.0625rem;
                        font-weight: 600;
                        color: #1a1a1a;
                        display: block;
                        line-height: 1.4;
                    }
                    
                    .reload_overlay_banner_actions {
                        display: flex;
                        gap: 10px;
                        justify-content: center;
                        flex-direction: row;
                    }
                    
                    .reload-button {
                        padding: 10px 20px;
                        background: #667eea;
                        color: white;
                        border: none;
                        border-radius: 8px;
                        cursor: pointer;
                        font-size: 0.875rem;
                        font-weight: 600;
                        transition: all 0.2s ease;
                        min-width: 110px;
                        flex: 1;
                    }
                    
                    .reload-button-cancel {
                        padding: 10px 20px;
                        background-color: #e5e7eb;
                        color: #374151;
                        border: none;
                        border-radius: 8px;
                        cursor: pointer;
                        font-size: 0.875rem;
                        font-weight: 600;
                        transition: all 0.2s ease;
                        min-width: 110px;
                        flex: 1;
                    }
                    
                    @media (max-width: 768px) {
                        .reload_overlay_banner {
                            width: 95% !important;
                            max-width: none !important;
                        }
                        .reload_overlay_banner_content {
                            padding: 16px !important;
                            gap: 10px !important;
                        }
                        .reload_overlay_banner_header {
                            flex-direction: column !important;
                            gap: 8px !important;
                        }
                        .reload_overlay_banner_icon svg {
                            width: 36px !important;
                            height: 36px !important;
                        }
                        .reload_overlay_banner_title {
                            font-size: 0.9375rem !important;
                            text-align: center;
                        }
                        .reload_overlay_banner_actions {
                            flex-direction: column !important;
                            gap: 8px !important;
                        }
                        .reload_overlay_banner_actions button,
                        .reload_overlay_banner_actions .reload-button {
                            width: 100% !important;
                            min-width: auto !important;
                            padding: 12px 16px !important;
                            flex: none !important;
                        }
                    }
                    .reload-button:hover {
                        transform: translateY(-1px);
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                        background: #5568d3;
                    }
                    .reload-button:active {
                        transform: translateY(0);
                    }
                    .reload-button-cancel:hover {
                        background-color: #d1d5db !important;
                    }
                `)));
    }
}
export default translate(connect(abstractMapStateToProps)(PageReloadOverlay));
